import React from "react";
import { AllergyCard, MedicalHistoryCard, ProviderNotesCard, UpcomingAppointmentsCard, VaccinationCard } from "components";
import DashboardWidgetManager from "../components/DashboardWidgetManager";



const DashboardWithSidebarTray = (props) => {
  const widgetComponentMap = {
  'app-appointments': UpcomingAppointmentsCard,
  'app-allergies': AllergyCard,
  'app-medical-history': MedicalHistoryCard,
  'app-provider-notes': ProviderNotesCard,
  'app-vaccination-immunization-record': VaccinationCard
};
  return (
    <DashboardWidgetManager 
      widgetComponentMap={widgetComponentMap} 
      userId={props.userId} 
      selectedFamilyMember={props.selectedFamilyMember}
      onRowClickforLabResults={props.onRowClickforLabResults}
    />
  );
};

export default DashboardWithSidebarTray;